export const ROUTES = Object.freeze({
  /**
   * 首頁
   */
  HOME: () => `/`,
  /**
   * 版本區(不是正式路由)
   */
  ABOUT: () => `/about`,
  /**
   * Demo 頁(不是正式路由)
   */
  DEMO: () => `/demo`,
  /**
   * 登入頁
   */
  LOGIN: () => `/login`,
  /**
   * 直屬代理管理
   * /agent-management?detail=member 直屬代理管理 - 會員
   * /agent-management?detail=agent 直屬代理管理 - 代理
   */
  AGENT_MANAGEMENT: (detail?: string, queryCode?: string) => `/agent-management${detail ? `?detail=${detail}` : ''}${queryCode ? `&queryCode=${queryCode}` : ''}`,
  /**
   */
  // AGENT_MANAGEMENT_MEMBER: () => `/agent-management/member`,
  /**
   * 直屬會員管理
   */
  PLAYER_MANAGEMENT: () => `/player-management`,
  /**
   * 邀請碼管理
   */
  INVITATION_CODE_GENERATOR: () => `/invitation-code-generator`,
  /**
   * 投注站報表
   */
  STATION_REPORT: () => `/station-report`,
  /**
   * 代理報表
   */
  DELEGATE_REPORT: () => `/delegate-report`,
  /**
   * 會員報表
   */
  PLAYER_REPORT: () => `/player-report`,
  /**
   * 佣金報表
   */
  COMMISSION_REPORT: () => `/commission-report`,
  /**
   * 資金明細
   */
  FUNDS_DETAILS: () => `/funds-details`,
  /**
   * 投注站兌換記錄
   */
  STATION_EXCHANGE_RECORD: () => `/station-exchange-record`,
  /**
   * 現金額度報表
   */
  STATION_QUOTA_CHANGE_LOG: () => `/station-quota-change-log`,
  /**
   * 充值記錄
   */
  RECHARGE_LIST: () => `/recharge-list`,
  /**
   * 提現記錄
   */
  WITHDRAW_LIST: () => `/withdraw-list`,
  /**
   * 實名驗證
   */
  KYC: () => `/kyc`,
  /**
   * 投注記錄
   */
  BET_RECORD: () => `/bet-record`,
  /**
   * 子帳號管理
   */
  SUB_ACCOUNT_MANAGEMENT: () => `/sub-account-management`,
  /**
   * 佣金提現
   */
  COMMISSION_WITHDRAWAL: () => `/commission-withdrawal`,
  /**
   * 密碼管理
   */
  UPDATE_PASSWORD: () => `/update-password`,
  /**
   * 投注站投注記錄
   */
  BETTING_BET_RECORD: () => `/betting-bet-record`,
})
